export default __webpack_public_path__ + "static/sloth_card_2-e16f3cc3cd3a2760815ce66fc224437c.png";